import { InstantSchema, type Instant } from "@/Temporal"
import { nullableSchema, objectSchema } from "vue-utils"
import type { Id, IncidentEntity, Nullable } from "../IncidentEntity"
import { UserTimeStamp } from "../UserTimeStamp"

export interface VtsLog extends IncidentEntity {
	logTime: Instant

	createdBy: UserTimeStamp
	editedBy: UserTimeStamp

	fromId: Id
	fromOther: Nullable<string>

	toId: Id
	toOther: Nullable<string>

	remarks: string
}

export const VtsLog = objectSchema<VtsLog>({
	id: Number,

	logTime: InstantSchema,

	createdBy: UserTimeStamp,
	editedBy: UserTimeStamp,

	fromId: Number,
	fromOther: nullableSchema(String),

	toId: Number,
	toOther: nullableSchema(String),

	remarks: String,
})
